var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F60E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFDD67",
    d: "M32 2c16.57 0 30 13.432 30 30S48.57 62 32 62C15.432 62 2 48.568 2 32S15.432 2 32 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#494949",
    d: "M35.849 20.473c-2.198 1.098-5.497 1.098-7.697 0-2.349-1.204-5.22-1.977-8.655-2.279-3.357-.294-10.469-.284-14.028.968a9.875 9.875 0 0 0-1.198.527c-.219.111-.262.193-.262.604v.527c0 .992-.124.608.585 1.02 1.38.809 2.165 2.91 2.586 5.801.598 4.213 2.666 6.854 6.022 8.115a13.471 13.471 0 0 0 9.69-.105c1.691-.676 3.176-1.742 4.356-3.477 2.067-3.037 1.448-4.936 2.515-7.547.932-2.277 3.542-2.277 4.473 0 1.068 2.611.449 4.51 2.516 7.547 1.18 1.734 2.665 2.801 4.355 3.477a13.474 13.474 0 0 0 9.691.105c3.355-1.262 5.424-3.902 6.022-8.115.421-2.891 1.204-4.992 2.585-5.801.709-.411.586-.027.586-1.02v-.527c0-.41-.045-.492-.262-.604a9.87 9.87 0 0 0-1.199-.527c-3.559-1.252-10.67-1.262-14.026-.969-3.436.303-6.307 1.076-8.655 2.28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M44.584 42.279c-8.109 5.656-17.105 5.623-25.168 0-.97-.677-1.845.495-1.187 1.578 2.457 4.047 7.417 7.65 13.771 7.65s11.314-3.604 13.771-7.65c.659-1.083-.216-2.254-1.187-1.578z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F60E);
export default __webpack_public_path__ + "static/media/1f60e.0a51bc3ec6baa497a803a77958bf2512.svg";
export { ForwardRef as ReactComponent };